<template>
    <div class="l-upload-main-inupt">
        <div class="l-upload-input-item">
            <div class="name">类型</div>
            <div class="select-text">{{ options.name }}</div>
        </div>
        <div class="l-upload-input-item">
            <div class="name">段位</div>

            <select ref="stage" @change="handleChangeStage">
                <option v-for="(item, index) in stageList" :key="index" :value="index">{{ item.name }}</option>
            </select>
        </div>
        <div class="l-upload-input-item">
            <div class="name">关卡</div>
            <select ref="level" @change="handleChangeLevel">
                <option v-for="(item, index) in levelList" :key="index" :value="index">{{ item.name }}</option>
            </select>
        </div>
        <div class="l-upload-input-item">
            <div class="name">故事</div>
            <select ref="story" @change="handleChangeStory">
                <option v-for="(item, index) in storyList" :key="index" :value="index">{{ item.name }}</option>
            </select>
        </div>
    </div>
</template>
<script>
import CourseModel from './../../../models/course'
const courseModel = new CourseModel()

export default {
    props: {
        options: {
            type: Object,
            default: () => {
                return {}
            }
        },
    },
    data() {
        return {
            typeData: {},
            stageList: [],// 段位
            levelList: [],// 关卡
            storyList: [],// 故事
            uploadData: {
                type: '',
                stage: '',
                level: '',
                story: '',

            }
        }
    },
    watch: {
        options(newValue) {
            this.typeData = newValue
            this.uploadData.type = this.typeData.name
            this.handleGetStage()
        }
    },
    mounted() {
    },
    methods: {
        // 获取段位
        handleGetStage() {
            let data = {
                type: this.typeData.type
            }
            courseModel.getNode(data).then(res => {
                if (res.status === 0) {
                    this.stageList = res.data
                    this.handleLevel(this.stageList[0].id)
                    this.uploadData.stage = this.stageList[0].name
                }
            })
        },

        // 获取关卡
        handleLevel(id) {
            courseModel.getNode({ id: id }).then(res => {
                if (res.status === 0) {
                    this.levelList = res.data
                    this.uploadData.level = this.levelList[0].name
                    this.handleStory(this.levelList[0].id)

                }
            })
        },
        // 获取故事
        handleStory(id) {
            courseModel.getNode({ id: id }).then(res => {
                if (res.status === 0) {
                    this.storyList = res.data
                    this.uploadData.story = this.storyList[0].name
                    this.handleEmit()
                }
            })

        },
        handleEmit() {
            this.$emit('getTypeData', this.uploadData)
        },

        // 选择段位
        handleChangeStage() {
            let data = this.stageList[this.$refs.stage.value]
            this.uploadData.stage = data.name
            this.$refs.level.value=0
            this.$refs.story.value=0
            this.handleLevel(data.id)
        },
        // 选择关卡

        handleChangeLevel() {
            let data = this.levelList[this.$refs.level.value]
            this.uploadData.level = data.name
            this.$refs.story.value=0
            this.handleStory(data.id)
        },
        // 选择故事
        handleChangeStory() {
            let data = this.storyList[this.$refs.story.value]
            this.uploadData.story = data.name
            this.handleEmit()
        }
    }
}
</script>
<style lang="stylus" scoped>
@import "./index.styl";
</style>